export default function Hero() {
  const stats = [
    { value: '每日更新', label: '实时爆料追踪' },
    { value: '7×24h', label: '全天候吃瓜运营' },
    { value: '千万瓜友', label: '活跃社区聚集' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20digital%20art%20with%20warm%20orange%20and%20deep%20crimson%20tones%2C%20dynamic%20flowing%20particles%20forming%20trending%20wave%20patterns%2C%20social%20media%20buzz%20visualization%2C%20modern%20editorial%20style%2C%20dark%20background%20with%20glowing%20warm%20highlights%2C%20energy%20and%20excitement%20atmosphere%2C%20clean%20composition%20suitable%20for%20text%20overlay%2C%20high%20contrast%20dramatic%20lighting&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="51每日大赛背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70 z-[1]"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12 pt-24 pb-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs font-medium text-accent-300 whitespace-nowrap">实时吃瓜 · 每日爆料</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4">
              51每日大赛
              <span className="block text-accent-300 text-xl md:text-2xl lg:text-3xl mt-2 font-body font-medium">
                吃瓜黑料实时爆料聚集地
              </span>
            </h1>

            <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-4">
              每日更新最热吃瓜事件，全网黑料一手掌握。
            </p>
            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              作为吃瓜爱好者的首选聚集地，51每日大赛汇集娱乐圈内幕、社会热点爆料、网红翻车实况等各类实时吃瓜内容。
              官网每日不间断更新，提供最新地址入口与app下载，确保瓜友随时随地畅享在线观看体验。
              当前热门：明星塌房全纪录、主播圈内幕揭秘、综艺名场面盘点。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-white">{s.value}</div>
                  <div className="text-xs md:text-sm text-white/60 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-white font-medium rounded-full transition-all duration-200 cursor-pointer text-sm"
              >
                <i className="ri-flashlight-line"></i>
                进入吃瓜现场
              </a>
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full border border-white/30 transition-all duration-200 cursor-pointer text-sm"
              >
                <i className="ri-download-line"></i>
                下载APP随时吃瓜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Vibrant%20trendy%20digital%20collage%20illustration%20representing%20social%20media%20gossip%20and%20breaking%20news%20aggregation%2C%20warm%20orange%20crimson%20and%20amber%20color%20palette%2C%20abstract%20geometric%20shapes%20with%20glowing%20accents%2C%20newspaper%20clipping%20aesthetic%20mixed%20with%20modern%20UI%20elements%2C%20trending%20topics%20visualization%2C%20dark%20depth%20with%20bright%20focal%20points%2C%20editorial%20quality%20digital%20art%2C%20dramatic%20composition%20with%20negative%20space&width=800&height=1000&seq=hero-visual-01&orientation=portrait"
                  alt="51每日大赛主视觉 - 吃瓜爆料聚集地"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-20 h-20 md:w-24 md:h-24 bg-accent-500 rounded-2xl flex items-center justify-center shadow-lg">
                <div className="text-center">
                  <div className="text-white text-lg md:text-xl font-heading font-bold leading-none">HOT</div>
                  <div className="text-white/80 text-[10px] md:text-xs mt-0.5">今日爆点</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}